<template>
    <div v-if="params.value">{{ params.value.split('T')[0] }}</div>
</template>

<script>
export default {
  name: 'CellRendererDOB'
}
</script>
